module.exports = __webpack_public_path__ + "officialStatic/img/index_about_us.61bc510.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/index/index_about_us.png
// module id = fiab
// module chunks = 0